/** Global just-intonation table (seed schema §6a). Per-raga intonation_overrides win. */
export const SWARASTHANA_TABLE = {
    S: { ratio: '1/1', cents: 0 },
    R1: { ratio: '16/15', cents: 112 }, R2: { ratio: '9/8', cents: 204 }, R3: { ratio: '6/5', cents: 316 },
    G1: { ratio: '9/8', cents: 204 }, G2: { ratio: '6/5', cents: 316 }, G3: { ratio: '5/4', cents: 386 },
    M1: { ratio: '4/3', cents: 498 }, M2: { ratio: '45/32', cents: 590 },
    P: { ratio: '3/2', cents: 702 },
    D1: { ratio: '8/5', cents: 814 }, D2: { ratio: '5/3', cents: 884 }, D3: { ratio: '9/5', cents: 1018 },
    // N1≡D2 (Shuddha Nishadam ≡ Chatushruti Dhaivatam = 884c); corrected from §6a mis-pairing (D3/N1 share 1018).
    N1: { ratio: '5/3', cents: 884 }, N2: { ratio: '9/5', cents: 1018 }, N3: { ratio: '15/8', cents: 1088 },
};
/** Cents for a swarasthana; a per-raga override (name→cents) wins over the global value. */
export function centsFor(name, overrides) {
    const o = overrides?.[name];
    return o !== undefined ? o : SWARASTHANA_TABLE[name].cents;
}
//# sourceMappingURL=swarasthanas.js.map